export function getProfileUrlByIdentifier(
  identifier?: string | null,
  isVanityPathname = true,
): string {
  if (!identifier) {
    return "/profile"
  }

  return isVanityPathname ? `/${identifier}` : `/profile/${identifier}`
}

export const PROFILE_TABS = [
  "activity",
  "created",
  "items",
  "offers",
  "deals",
  "listings",
  "watchlist",
  "favorites",
  "portfolio",
  "created",
  "tokens",
  "galleries",

  // Special OG Image path
  "opengraph-image",
]

const nonItemTabs = PROFILE_TABS.filter(tab => tab !== "items")

export const pathnameHasIdentifier = (pathname: string) => {
  const parts = pathname.split("/").filter(Boolean)

  if (isVanityPathname(pathname)) {
    return true
  }

  return parts.length > 1 && !nonItemTabs.includes(parts[1])
}

export const isVanityPathname = (pathname: string) => {
  const parts = pathname.split("/").filter(Boolean)
  return parts[0] !== "profile"
}
